import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import GroupForm from '../components/GroupForm';

import useScreens, { POOL_DETAILS_SLUG } from './useScreens';

import {
    combinationCount,
    combinationPrice,
    selections,
} from '../../../components/big9/selectors';

import useGroupList from 'features/SpilKlub/state/useGroupList';
import { GROUP_TYPE_CAPTAIN_GROUP } from 'features/SpilKlub/state/useGroupInfiniteList';
import Text from 'ui/Text';
import '../styles/create_pool_group.css';
import newGroupIcon from './../../../images/icons/big9/new-group-icon.svg';
import successIcon from './../../../images/success_icon_revert.svg';
import { NotificationManager } from 'react-notifications';
import texts from 'features/SpilKlub/texts';
import useTweaks from 'features/SpilKlub/state/useTweaks';
import { bindActionCreators } from 'redux';
import * as UiActions from 'actions/UiActions';
import * as AuthActions from 'actions/AuthActions';
import GroupAvatar, { GroupChoice } from '../components/GroupAvatar';

const TYPES = {
    CREATE_POOL: 'CREATE_POOL',
    CREATE_GROUP: 'CREATE_GROUP',
};

const LOW_BALANCE_ERROR_MESSAGE =
    'Din balance er for lav, for at købe andele skal du først foretage en indbetaling.';

const serializeGroupData = (group) => {
    return {
        name: group.name,
        deadline: Number(group.settings.deadlineTime),
        sharePrice: Number(group.settings.sharePrice),
        maxShares: Number(group.settings.sharesLimit),
        isPublic: group.publicGroup,
    };
};

import { APP_PATH } from '../../../constants/appConfig';

const DESCRIPTION = [
    'Som holdkaptajn, sætter du kriterierne for din SpilKlub.',
    'Det er muligt at oprette flere klubber, så du f.eks. kan have en SpilKlub med hhv. kollegaer og en privat vennegruppe. Når du opretter et nyt spil til en ny runde, er det muligt at vælge de eksisterende grupper, du har oprettet tidligere.',
    'Deadline for køb betyder, at det ikke længere er muligt at købe andele til din SpilKlub efter deadline er passeret. Hvis du f.eks. vælger 30 min. før start, vil det ikke være muligt at købe efter kl. 15.30, hvis Big 9 runden starter kl. 16.',
    'Du skal også selv bestemme andelsprisen og antal andele du vil sælge. Hvis du har sat andelsprisen til 50 kr., køber man én andel for 50 kr. og to andele for 100 kr osv.. Maks. antal andele er det totale du sælge inklusiv din egen andel(e).',
    'Du kan godt oprette en SpilKlub uden at købe andele.',
    'Til sidst har du mulighed for at gøre din SpilKlub offentlig for alle på sitet eller privat for dig og de du deler linket til SpilKlubben med.',
];

const CreateGroup = ({
    userId,
    selections,
    combinationPrice,
    combinationCount,
    uiActions,
    authActions,
    auth,
}) => {
    const [creationType, setCreationType] = useState(TYPES.CREATE_POOL);
    const [defaultValues, setDefaultValues] = useState(null);
    const balance = auth?.user?.balance;
    const onError = (error) => {
        if (error.message !== LOW_BALANCE_ERROR_MESSAGE) {
            NotificationManager.error(error.message);
        }
    };
    const [groupId, setGroupId] = useState(null);
    const [groupName, setGroupName] = useState('');
    const { data } = useGroupList({ groupType: GROUP_TYPE_CAPTAIN_GROUP });
    const { setScreen } = useScreens();
    const {
        setUIGroupId,
        createPoolWithCouponMode: poolMode,
        disablePoolWithCoupon,
    } = useTweaks();

    let filterTimeout;
    const createGroupName = (query) => {
        clearTimeout(filterTimeout);
        if (!query) return setGroupName('');

        filterTimeout = setTimeout(() => {
            setGroupName(query);
        }, 500);
    };

    const onSuccess = (response) => {
        const { poolHash, groupId } = response;
        NotificationManager.success(texts.betslip.couponAdded);
        setTimeout(() => {
            poolMode && disablePoolWithCoupon();
            setScreen(POOL_DETAILS_SLUG, poolHash);
            setUIGroupId(groupId);
            authActions.updateBalance();
        }, 200);
    };

    const createGroup = () => {
        setDefaultValues(null);
        setGroupId(null);
        setCreationType(TYPES.CREATE_GROUP);
    };

    useEffect(
        // set first group as a selected one by default
        () => {
            if (data?.groups?.length && creationType === TYPES.CREATE_POOL) {
                setDefaultValues(serializeGroupData(data?.groups[0]));
                setGroupId(data?.groups[0].poolTemplateId);
            }
        },
        [data]
    );

    const getDescription = () => {
        return DESCRIPTION.map((item, key) => {
            return (
                <Text
                    align={'left'}
                    margin={'0 0 20px'}
                    padding={'0'}
                    size={'12'}
                    lh={'18'}
                    color={'#333'}
                    key={key}
                >
                    {item}
                </Text>
            );
        });
    };

    return (
        <div className="sk-group-wrapper container-md">
            {window.innerWidth > 1000 ? (
                <div className="sk-group-sidebar">
                    <Text
                        align={'left'}
                        margin={'0 0 10px'}
                        padding={'0'}
                        size={'16'}
                        bold
                        color={'#333'}
                    >
                        Sådan fungerer SpilKlub25
                    </Text>
                    {getDescription()}
                </div>
            ) : null}
            <div className={'sk-group-content'}>
                {creationType === TYPES.CREATE_POOL && data?.groups?.length ? (
                    <div className={'sk-group-avatars'}>
                        <Text color={'#333'} size={'x07'} padding={'0 0 8px 0'}>
                            Tilføj til eksisterende klub
                        </Text>
                        <div className={'sk-group-avatars-wrapper'}>
                            <div
                                className={
                                    'flex-column align-center sk-group-choice-item'
                                }
                                onClick={createGroup}
                            >
                                <img
                                    className={'sk-new-group-icon'}
                                    src={newGroupIcon}
                                    alt="newGroupIcon"
                                />
                                <Text
                                    color={'#333'}
                                    size={'x07'}
                                    padding={'0'}
                                    align={'center'}
                                    short
                                >
                                    Opret ny klub
                                </Text>
                            </div>
                            {data.groups.map((group, key) => (
                                <div
                                    className={`sk-group-choice-item flex-column align-center ${group.poolTemplateId ===
                                        groupId && 'sk-active-group'}`}
                                    key={key}
                                    onClick={() => {
                                        setDefaultValues(
                                            serializeGroupData(group)
                                        );
                                        setGroupId(group.poolTemplateId);
                                    }}
                                >
                                    <GroupChoice
                                        groupName={group.name}
                                        avatarUrl={
                                            group?.avatarUrl
                                                ? `${group?.avatarUrl}`
                                                : ''
                                        }
                                        active={
                                            group.poolTemplateId === groupId
                                        }
                                        icon={
                                            group.poolTemplateId ===
                                                groupId && (
                                                <img
                                                    src={successIcon}
                                                    alt="active"
                                                    className={
                                                        'sk-active-group-icon'
                                                    }
                                                />
                                            )
                                        }
                                    />
                                    <Text
                                        color={'#333'}
                                        size={'x07'}
                                        padding={'0'}
                                        align={'center'}
                                        short
                                    >
                                        {group.name}
                                    </Text>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                    <div className="flex justify-center align-center">
                        <GroupAvatar groupName={groupName} />
                    </div>
                )}

                <GroupForm
                    userId={userId}
                    uiActions={uiActions}
                    onError={onError}
                    balance={balance}
                    onSuccess={onSuccess}
                    defaults={defaultValues}
                    groupId={groupId}
                    combinationPrice={combinationPrice}
                    combinationCount={combinationCount}
                    selections={selections}
                    poolMode={poolMode}
                    changeName={(groupName) => {
                        if (
                            !data?.groups?.length ||
                            creationType === TYPES.CREATE_GROUP
                        ) {
                            createGroupName(groupName);
                        }
                    }}
                />
            </div>
        </div>
    );
};

const stateToProps = (state) => ({
    combinationPrice: combinationPrice(state),
    combinationCount: combinationCount(state),
    selections: selections(state),
    auth: state.auth,
});

const dispatchToProps = (dispatch) => ({
    uiActions: bindActionCreators(UiActions, dispatch),
    authActions: bindActionCreators(AuthActions, dispatch),
});

export const ConnectedCreateGroupScreen = connect(
    stateToProps,
    dispatchToProps
)(CreateGroup);

export default CreateGroup;
